<template>
  <span         @click="data.visible = !data.visible">
    <div>
      <v-row>
        <v-col>
          <p class="title">
            {{data.title}}
          </p>
        </v-col>

        <img v-if="data.visible"
          src="../../assets/pinjaman/minus-circle.png"
          srcset="
            ../../assets/pinjaman/minus-circle@2x.png 2x,
            ../../assets/pinjaman/minus-circle@3x.png 3x
          "
          class="minus-circle"
        />
         <img v-else
          src="../../assets/pinjaman/plus-circle.png"
          srcset="
            ../../assets/pinjaman/plus-circle@2x.png 2x,
            ../../assets/pinjaman/plus-circle@3x.png 3x
          "
          class="plus-circle"
        />
      </v-row>

      <p class="Desc" v-if="data.visible">
        {{data.detail}}
      </p>
      <p class="Fade-Out" v-if="!data.visible">
        
      </p>
    </div>

    <v-divider />
  </span>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {};
  },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');
.Question {
  /* width: 1048px; */
  height: 361px;
  flex-grow: 0;
  margin: 50px 0 0;
  padding: 20px 0 0;
}
.title {
  /* width: 533px; */
  height: 22px;
  flex-grow: 0;
  /* margin: 0 495px 12px 0; */
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Desc {
  /* width: 972px; */
  max-height: 38px;
  flex-grow: 0;
  /* margin: 12px 56px 20px 0; */
  font-family: 'Inter';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
   animation: fadein 1s;
}
.minus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 13px 56px;
  object-fit: contain;
}
.plus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 20px 56px;
  object-fit: contain;
  display: inline;
}
.Fade-Out{
  animation: fadeout 1s;
}

@keyframes fadein {
    0% { opacity: 0; height:0px; }
    20%   { opacity: 0.6; height:20%;}
    100% { opacity: 1; height:100%;}
}

@keyframes fadeout {
    0% { opacity: 0; height:38px; }
    20%   { opacity: 0.6; height:10px}
    100% { opacity: 1; height:0px}
}
</style>
